import { render, staticRenderFns } from "./BasicLayout.vue?vue&type=template&id=aa1543be&scoped=true&"
import script from "./BasicLayout.vue?vue&type=script&lang=ts&"
export * from "./BasicLayout.vue?vue&type=script&lang=ts&"
import style0 from "./BasicLayout.vue?vue&type=style&index=0&id=aa1543be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1543be",
  null
  
)

export default component.exports